const S = Object.keys;
function j(s) {
  return typeof s == "boolean";
}
function U(s) {
  return s && typeof s.nodeType == "number";
}
function B(s) {
  return typeof s == "string";
}
function I(s) {
  return typeof s == "number";
}
function w(s) {
  return typeof s == "object" ? s !== null : v(s);
}
function v(s) {
  return typeof s == "function";
}
function Y(s) {
  return !!(s && s.isComponent);
}
function W(s) {
  return w(s) && typeof s.length == "number" && typeof s.nodeType != "number";
}
function x(s, t) {
  if (s)
    for (const e of S(s))
      t(s[e], e);
}
function G(s) {
  return w(s) && "current" in s;
}
const A = {
  animationIterationCount: 0,
  borderImageOutset: 0,
  borderImageSlice: 0,
  borderImageWidth: 0,
  boxFlex: 0,
  boxFlexGroup: 0,
  boxOrdinalGroup: 0,
  columnCount: 0,
  columns: 0,
  flex: 0,
  flexGrow: 0,
  flexPositive: 0,
  flexShrink: 0,
  flexNegative: 0,
  flexOrder: 0,
  gridArea: 0,
  gridRow: 0,
  gridRowEnd: 0,
  gridRowSpan: 0,
  gridRowStart: 0,
  gridColumn: 0,
  gridColumnEnd: 0,
  gridColumnSpan: 0,
  gridColumnStart: 0,
  fontWeight: 0,
  lineClamp: 0,
  lineHeight: 0,
  opacity: 0,
  order: 0,
  orphans: 0,
  tabSize: 0,
  widows: 0,
  zIndex: 0,
  zoom: 0,
  // SVG-related properties
  fillOpacity: 0,
  floodOpacity: 0,
  stopOpacity: 0,
  strokeDasharray: 0,
  strokeDashoffset: 0,
  strokeMiterlimit: 0,
  strokeOpacity: 0,
  strokeWidth: 0
};
function Z(s, t) {
  return s + t.charAt(0).toUpperCase() + t.substring(1);
}
const q = ["Webkit", "ms", "Moz", "O"];
S(A).forEach((s) => {
  q.forEach((t) => {
    A[Z(t, s)] = 0;
  });
});
const V = /* @__PURE__ */ Symbol.for("jsx-dom:type");
var R = /* @__PURE__ */ (function(s) {
  return s.ShadowRoot = "ShadowRoot", s;
})(R || {});
function J(s) {
  return s != null && s[V] === R.ShadowRoot;
}
const Q = "http://www.w3.org/2000/svg", tt = "http://www.w3.org/1999/xlink", et = "http://www.w3.org/XML/1998/namespace";
function F(s) {
  return !j(s) && s != null;
}
function T(s) {
  return Array.isArray(s) ? s.map(T).filter(Boolean).join(" ") : w(s) ? Symbol.iterator in s ? T(Array.from(s)) : S(s).filter((t) => s[t]).join(" ") : F(s) ? "" + s : "";
}
const st = {
  animate: 0,
  circle: 0,
  clipPath: 0,
  defs: 0,
  desc: 0,
  ellipse: 0,
  feBlend: 0,
  feColorMatrix: 0,
  feComponentTransfer: 0,
  feComposite: 0,
  feConvolveMatrix: 0,
  feDiffuseLighting: 0,
  feDisplacementMap: 0,
  feDistantLight: 0,
  feFlood: 0,
  feFuncA: 0,
  feFuncB: 0,
  feFuncG: 0,
  feFuncR: 0,
  feGaussianBlur: 0,
  feImage: 0,
  feMerge: 0,
  feMergeNode: 0,
  feMorphology: 0,
  feOffset: 0,
  fePointLight: 0,
  feSpecularLighting: 0,
  feSpotLight: 0,
  feTile: 0,
  feTurbulence: 0,
  filter: 0,
  foreignObject: 0,
  g: 0,
  image: 0,
  line: 0,
  linearGradient: 0,
  marker: 0,
  mask: 0,
  metadata: 0,
  path: 0,
  pattern: 0,
  polygon: 0,
  polyline: 0,
  radialGradient: 0,
  rect: 0,
  stop: 0,
  svg: 0,
  switch: 0,
  symbol: 0,
  text: 0,
  textPath: 0,
  tspan: 0,
  use: 0,
  view: 0
}, it = /^(a(ll|t|u)|base[FP]|c(al|lipPathU|on)|di|ed|ex|filter[RU]|g(lyphR|r)|ke|l(en|im)|ma(rker[HUW]|s)|n|pat|pr|point[^e]|re[^n]|s[puy]|st[^or]|ta|textL|vi|xC|y|z)/;
function nt(s) {
  const t = document.createDocumentFragment();
  return E(s.children, t), t;
}
function ot(s, t, e) {
  t = {
    ...t,
    children: e
  };
  const i = new s(t), n = i.render();
  return "ref" in t && M(t.ref, i), n;
}
function c(s, t) {
  let { children: e, ...i } = t;
  !i.namespaceURI && st[s] === 0 && (i = {
    ...i,
    namespaceURI: Q
  });
  let n;
  if (B(s)) {
    if (n = i.namespaceURI ? document.createElementNS(i.namespaceURI, s) : document.createElement(s), at(i, n), E(e, n), n instanceof window.HTMLSelectElement && i.value != null)
      if (i.multiple === !0 && Array.isArray(i.value)) {
        const o = i.value.map((l) => String(l));
        n.querySelectorAll("option").forEach(
          (l) => l.selected = o.includes(l.value)
        );
      } else
        n.value = i.value;
    M(i.ref, n);
  } else if (v(s))
    w(s.defaultProps) && (i = {
      ...s.defaultProps,
      ...i
    }), n = Y(s) ? ot(s, i, e) : s({
      ...i,
      children: e
    });
  else
    throw new TypeError(`Invalid JSX element type: ${s}`);
  return n;
}
function M(s, t) {
  G(s) ? s.current = t : v(s) && s(t);
}
function E(s, t) {
  if (W(s))
    rt(s, t);
  else if (B(s) || I(s))
    L(document.createTextNode(s), t);
  else if (s === null)
    L(document.createComment(""), t);
  else if (U(s))
    L(s, t);
  else if (J(s)) {
    const e = t.attachShadow(s.attr);
    E(s.children, e), M(s.ref, e);
  }
}
function rt(s, t) {
  for (const e of [...s])
    E(e, t);
  return t;
}
function L(s, t) {
  t instanceof window.HTMLTemplateElement ? t.content.appendChild(s) : t.appendChild(s);
}
function C(s, t) {
  return s.replace(/[A-Z]/g, (e) => t + e.toLowerCase());
}
function K(s, t) {
  t == null || t === !1 || (Array.isArray(t) ? t.forEach((e) => K(s, e)) : B(t) ? s.setAttribute("style", t) : w(t) && x(t, (e, i) => {
    i.indexOf("-") === 0 ? s.style.setProperty(i, e) : I(e) && A[i] !== 0 ? s.style[i] = e + "px" : s.style[i] = e;
  }));
}
function lt(s, t, e) {
  switch (s) {
    case "xlinkActuate":
    case "xlinkArcrole":
    case "xlinkHref":
    case "xlinkRole":
    case "xlinkShow":
    case "xlinkTitle":
    case "xlinkType":
      _(e, tt, C(s, ":"), t);
      return;
    case "xmlnsXlink":
      b(e, C(s, ":"), t);
      return;
    case "xmlBase":
    case "xmlLang":
    case "xmlSpace":
      _(e, et, C(s, ":"), t);
      return;
  }
  switch (s) {
    case "htmlFor":
      b(e, "for", t);
      return;
    case "dataset":
      x(t, (i, n) => {
        i != null && (e.dataset[n] = i);
      });
      return;
    case "innerHTML":
    case "innerText":
    case "textContent":
      F(t) && (e[s] = t);
      return;
    case "dangerouslySetInnerHTML":
      w(t) && (e.innerHTML = t.__html);
      return;
    case "value":
      if (t == null || e instanceof window.HTMLSelectElement)
        return;
      if (e instanceof window.HTMLTextAreaElement) {
        e.value = t;
        return;
      }
      break;
    case "spellCheck":
      e.spellcheck = t;
      return;
    case "class":
    case "className":
      v(t) ? t(e) : b(e, "class", T(t));
      return;
    case "ref":
    case "namespaceURI":
      return;
    case "style":
      K(e, t);
      return;
    case "on":
    case "onCapture":
      x(t, (i, n) => {
        e.addEventListener(n, i, s === "onCapture");
      });
      return;
  }
  if (v(t)) {
    if (s[0] === "o" && s[1] === "n") {
      let i = s.toLowerCase();
      const n = i.endsWith("capture");
      if (i === "ondoubleclick" ? i = "ondblclick" : n && i === "ondoubleclickcapture" && (i = "ondblclickcapture"), !n && e[i] === null)
        e[i] = t;
      else if (n)
        e.addEventListener(
          i.substring(2, i.length - 7),
          t,
          !0
        );
      else {
        let o;
        i in window ? o = i.substring(2) : o = i[2] + s.slice(3), e.addEventListener(o, t);
      }
    }
  } else w(t) ? e[s] = t : t === !0 ? b(e, s, "") : t !== !1 && t != null && (e instanceof SVGElement && !it.test(s) ? b(e, C(s, "-"), t) : b(e, s, t));
}
function b(s, t, e) {
  s.setAttribute(t, e);
}
function _(s, t, e, i) {
  s.setAttributeNS(t, e, i);
}
function at(s, t) {
  for (const e of S(s))
    lt(e, s[e], t);
  return t;
}
var P = /* @__PURE__ */ ((s) => (s.Init = "modal.init", s.BeforeShow = "modal.beforeShow", s.Show = "modal.show", s.BeforeClose = "modal.beforeClose", s.Close = "modal.close", s.Destroy = "modal.destroy", s.ToastShow = "toast.show", s.ToastClose = "toast.close", s))(P || {});
let ct = 0;
const z = (s) => `${s}-${++ct}`;
function k(s) {
  return s instanceof Node ? s : document.createTextNode(String(s));
}
function p(s, t) {
  if (!s) throw new Error(`${t ?? "Element"} not found`);
  return s;
}
function H(s) {
  const t = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])'
  ].join(",");
  return Array.from(s.querySelectorAll(t)).filter(
    (e) => !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
  );
}
function h(s, t = {}) {
  const e = document.createElement(s);
  if (t.className && (e.className = t.className), t.html != null && (e.innerHTML = t.html), t.text != null && (e.textContent = t.text), t.attrs)
    for (const [i, n] of Object.entries(t.attrs)) e.setAttribute(i, n);
  return e;
}
const ht = typeof navigator < "u" && /Mac|iPhone|iPad|iPod/i.test(navigator.platform), X = ["ctrl", "alt", "shift", "meta"];
function dt(s) {
  if (!s) return null;
  const t = String(s).trim().toLowerCase().split(/[+\-\s]+/g).filter(Boolean), e = [];
  let i = null;
  const n = (l) => {
    e.includes(l) || e.push(l);
  };
  for (const l of t) {
    let r = l;
    if (r === "control" || r === "ctrl") {
      n("ctrl");
      continue;
    }
    if (r === "alt" || r === "option") {
      n("alt");
      continue;
    }
    if (r === "shift") {
      n("shift");
      continue;
    }
    if (r === "meta" || r === "cmd" || r === "command" || r === "super") {
      n("meta");
      continue;
    }
    if (r === "mod") {
      n(ht ? "meta" : "ctrl");
      continue;
    }
    r === "esc" && (r = "escape"), r === "return" && (r = "enter"), (r === "space" || r === "spacebar") && (r = "space"), i = r;
  }
  const o = X.filter((l) => e.includes(l));
  return !i || i === "" ? o.length ? o.join("+") : null : o.length ? `${o.join("+")}+${i}` : i;
}
function ft(s) {
  const t = [];
  s.ctrlKey && t.push("ctrl"), s.altKey && t.push("alt"), s.shiftKey && t.push("shift"), s.metaKey && t.push("meta");
  let e = s.key;
  e === " " && (e = "space");
  const i = (e.length === 1, e.toLowerCase()), n = X.filter((o) => t.includes(o));
  return n.length ? `${n.join("+")}+${i}` : i;
}
class ut {
  constructor() {
    this.zBase = 1e3, this.stack = [];
  }
  push(t) {
    this.stack.push(t), this.syncZ();
  }
  remove(t) {
    this.stack = this.stack.filter((e) => e !== t), this.syncZ();
  }
  top() {
    return this.stack[this.stack.length - 1];
  }
  closeAll(t, e) {
    const i = new Set((Array.isArray(e) ? e : e ? [e] : []).map(String)), n = new Set((Array.isArray(t) ? t : t ? [t] : []).map(String));
    [...this.stack].reverse().forEach((o) => {
      const l = o.modalId, r = n.size ? n.has(o.pluginName) : !0, a = i.has(l);
      r && !a && o.close();
    });
  }
  removeAll() {
    [...this.stack].forEach((t) => t.destroy()), this.stack = [];
  }
  syncZ() {
    this.stack.forEach((t, e) => t.setZIndex(this.zBase + e * 2));
  }
  lockBodyScroll() {
    document.body.classList.add("ipe-modal-no-scroll");
  }
  unlockBodyScroll() {
    document.body.classList.remove("ipe-modal-no-scroll");
  }
}
const d = new ut();
class N {
  constructor(t = {}) {
    this.backdropId = z("ipe-modal-backdrop"), this.modalId = z("ipe-modal"), this.numberId = this.modalId.split("-")[1], this._isDestroyed = !1, this.pluginName = "normalModal", this.buttonElsLeft = [], this.buttonElsRight = [], this.keyMap = /* @__PURE__ */ new Map(), this.isOpen = !1, this.isToast = !1, this.isDragging = !1, this.dragStartX = 0, this.dragStartY = 0, this.modalStartX = 0, this.modalStartY = 0, this.Event = P, this._hooks = [], this.startCloseTimer = (e) => {
      this.stopCloseTimer(), this.closeTimer = window.setTimeout(() => this.close(), e);
    }, this.stopCloseTimer = () => {
      this.closeTimer && window.clearTimeout(this.closeTimer), this.closeTimer = void 0;
    }, this.onDragMove = (e) => {
      if (!this.isDragging) return;
      e.preventDefault();
      const i = e.clientX - this.dragStartX, n = e.clientY - this.dragStartY, o = this.get$modal(), l = this.modalStartX + i, r = this.modalStartY + n;
      o.style.left = `${l}px`, o.style.top = `${r}px`;
    }, this.onDragEnd = () => {
      if (!this.isDragging) return;
      this.isDragging = !1, document.removeEventListener("pointermove", this.onDragMove), document.removeEventListener("pointerup", this.onDragEnd);
      const e = this.get$modal(), i = this.get$window();
      e.classList.remove("is-dragging"), i.style.animation = "none", requestAnimationFrame(() => {
        this.applyAnimation(!0);
      });
    }, this.options = { ...N.DEFAULT_OPTIONS, ...t }, this.options.backdrop === !1 && t.bodyScroll === void 0 && (this.options.bodyScroll = !0);
  }
  get isDestroyed() {
    return this._isDestroyed;
  }
  static {
    this.DEFAULT_OPTIONS = {
      className: "",
      sizeClass: "auto",
      center: !0,
      fitScreen: !1,
      closeIcon: !0,
      bodyScroll: !1,
      outSideClose: !0,
      backdrop: !0,
      animation: {
        show: "ipe-modal-fade-in",
        hide: "ipe-modal-fade-out"
      },
      animationSpeed: 200
    };
  }
  static extends(t = {}) {
    return class extends this {
      constructor(e = {}) {
        super({ ...t, ...e });
      }
    };
  }
  // ------------------------------ lifecycle ------------------------------ //
  init() {
    if (this.$modal) return this;
    const t = this.options.backdrop !== !1;
    let e;
    t && (e = h("div", {
      className: "ipe-modal-backdrop",
      attrs: { id: this.backdropId, "data-modal-id": this.modalId }
    }));
    const i = h("div", {
      className: "ipe-modal-modal",
      attrs: { id: this.modalId, role: "dialog", "aria-modal": "true", tabindex: "-1" }
    });
    if (i.modal = this, !t) {
      i.classList.add("no-backdrop");
      const m = window.pageYOffset || document.documentElement.scrollTop, $ = window.pageXOffset || document.documentElement.scrollLeft, D = window.innerWidth;
      i.style.top = `${m + 60}px`, this.once("modal.show", () => {
        i.style.left = `${$ + D / 2 - i.offsetWidth / 2}px`;
      });
    }
    const n = h("div", {
      className: `ipe-modal-modal__window size--${this.options.sizeClass || "auto"} plugin--${this.pluginName}`
    });
    n.modal = this;
    const o = h("div", { className: "ipe-modal-modal__header" }), l = `${this.modalId}-title`, r = h("h2", {
      className: "ipe-modal-modal__title",
      attrs: { id: l, role: "heading", "aria-level": "2" }
    });
    i.setAttribute("aria-labelledby", l);
    const a = h("div", { className: "ipe-modal-modal__icons" });
    if (this.options.closeIcon) {
      const m = h("button", {
        className: "ipe-modal-modal__close",
        attrs: { type: "button", "aria-label": "Close" },
        html: "&times;"
      });
      m.addEventListener("click", () => {
        let $ = !0;
        typeof this.options.onClickClose == "function" ? this.options.onClickClose(this) === !1 && ($ = !1) : this.options.onClickClose === !1 && ($ = !1), $ && this.close();
      }), a.appendChild(m);
    }
    o.append(r, a), this.options.draggable && t && (this.options.draggable = !1), this.options.draggable && (o.style.cursor = "move", o.style.userSelect = "none", o.addEventListener("pointerdown", this.onDragStart.bind(this)), i.classList.add("is-draggable"));
    const u = h("div", { className: "ipe-modal-modal__content" }), f = h("div", { className: "ipe-modal-modal__footer" }), y = h("div", {
      className: "ipe-modal-modal__buttons ipe-modal-modal__buttons--left"
    }), O = h("div", {
      className: "ipe-modal-modal__buttons ipe-modal-modal__buttons--right"
    });
    return f.append(y, O), n.append(o, u, f), i.appendChild(n), this.$backdrop = e, this.$modal = i, this.$window = n, this.$header = o, this.$title = r, this.$icons = a, this.$content = u, this.$footer = f, this.$buttonsLeft = y, this.$buttonsRight = O, this.options.title && this.setTitle(this.options.title), this.options.content && this.setContent(this.options.content), this.options.buttons?.length ? this.setButtons(this.options.buttons) : f.style.display = "none", this.options.center && this.$modal.classList.add("is-centered"), this.options.fitScreen && this.$modal.classList.add("is-fullscreen"), this.options.iconButtons && this.$header.classList.add("has-icon-buttons"), this.options.className && this.$window.classList.add(...this.options.className.split(/[\s\.#+]+/g).filter(Boolean)), typeof this.options.fixedHeight == "number" ? this.$window.style.height = `${Math.max(0, this.options.fixedHeight)}px` : this.options.fixedHeight === !0 && this.$window.classList.add("is-fixed-height"), e && e.addEventListener("pointerup", (m) => {
      this.options.outSideClose && m.target === e && this.close();
    }), this.options.draggable && n.addEventListener("pointerdown", (m) => {
      m.target && n.contains(m.target) && this.bringToFront();
    }), this.onKeyDown = this.onKeyDown.bind(this), this.emit(
      "modal.init"
      /* Init */
    ), this;
  }
  show() {
    if (this.$modal || this.init(), !this.$modal) throw new Error("Failed to initialize modal");
    if (this.isOpen) return this;
    {
      const i = this.emit("modal.beforeShow", !0), n = this.options.beforeShow ? this.options.beforeShow(this) !== !1 : !0;
      if (!i || !n) return this;
    }
    this.lastFocused = document.activeElement ?? null, this.$backdrop && document.body.appendChild(this.$backdrop), document.body.appendChild(this.$modal), this.shouldLockBodyOnOpen() && d.lockBodyScroll(), requestAnimationFrame(() => {
      this.$backdrop?.classList.add("is-open"), this.$modal.classList.add("is-open"), this.applyAnimation(!0), this.focusFirst();
    }), document.addEventListener("keydown", this.onKeyDown), d.push(this), this.isOpen = !0, this.options.onShow?.(this), this.emit(
      "modal.show"
      /* Show */
    );
    const t = typeof this.options.closeAfter == "number" ? this.options.closeAfter : this.options.closeAfter?.time, e = typeof this.options.closeAfter == "number" ? !0 : this.options.closeAfter?.resetOnHover;
    return t && (this.startCloseTimer(t), e && (this.$window?.addEventListener("mouseenter", this.stopCloseTimer), this.$window?.addEventListener("mouseleave", () => this.startCloseTimer(t)))), this;
  }
  close() {
    if (!this.isOpen) return this;
    {
      const o = this.emit("modal.beforeClose", !0), l = this.options.beforeClose ? this.options.beforeClose(this) !== !1 : !0;
      if (!o || !l) return this;
    }
    if (this.isToast) {
      this.applyAnimation(!1), this.emit(
        "modal.close"
        /* Close */
      ), this.emit(
        "toast.close"
        /* ToastClose */
      );
      const o = this.isAnimationDisabled() ? 0 : this.options.animationSpeed ?? 200;
      let l = !1;
      const r = () => {
        l || (l = !0, this.destroy(), this.options.onClose?.(this));
      }, a = (u, f) => {
        const y = () => {
          u.removeEventListener(f, y), r();
        };
        u.addEventListener(f, y, { once: !0 });
      };
      return o > 0 && this.$window ? (a(this.$window, "transitionend"), a(this.$window, "animationend"), window.setTimeout(r, o + 20)) : window.setTimeout(r, o), this;
    }
    this.applyAnimation(!1), this.$backdrop?.classList.remove("is-open"), this.$modal?.classList.remove("is-open"), this.emit(
      "modal.close"
      /* Close */
    );
    const t = this.isAnimationDisabled() ? 0 : this.options.animationSpeed ?? 200;
    let e = !1;
    const i = () => {
      e || (e = !0, this.destroy(), this.options.onClose?.(this));
    }, n = (o, l) => {
      const r = () => {
        o.removeEventListener(l, r), i();
      };
      o.addEventListener(l, r, { once: !0 });
    };
    return t > 0 && this.$window ? (n(this.$window, "transitionend"), n(this.$window, "animationend"), window.setTimeout(i, t + 20)) : window.setTimeout(i, t), this;
  }
  /** Immediately removes DOM and listeners */
  destroy() {
    if (this._isDestroyed) return this;
    if (this.stopCloseTimer(), document.removeEventListener("keydown", this.onKeyDown), this.isDragging && this.onDragEnd(), this.$window?.removeEventListener("mouseenter", this.stopCloseTimer), this.isToast) {
      this.$window?.parentElement && this.$window.parentElement.removeChild(this.$window);
      const t = g.indexOf(this);
      t !== -1 && g.splice(t, 1);
    } else
      this.$backdrop?.parentElement && this.$backdrop.parentElement.removeChild(this.$backdrop), this.$modal?.parentElement && this.$modal.parentElement.removeChild(this.$modal), d.remove(this), this.shouldUnlockBodyOnClose() && d.unlockBodyScroll();
    return this.isOpen = !1, this.lastFocused?.focus?.(), this.emit(
      "modal.destroy"
      /* Destroy */
    ), this._isDestroyed = !0, this;
  }
  // ------------------------------ getters ------------------------------- //
  get$backdrop() {
    return this.$backdrop;
  }
  get$modal() {
    return p(this.$modal, "modal");
  }
  get$window() {
    return p(this.$window, "window");
  }
  get$header() {
    return p(this.$header, "header");
  }
  get$title() {
    return p(this.$title, "title");
  }
  get$content() {
    return p(this.$content, "content");
  }
  get$icons() {
    return p(this.$icons, "icons");
  }
  get$buttons(t) {
    return t === "leftButtons" ? p(this.$buttonsLeft, "leftButtons") : t === "rightButtons" ? p(this.$buttonsRight, "rightButtons") : p(this.$footer, "buttons");
  }
  // ------------------------------ content ------------------------------- //
  setTitle(t) {
    const e = this.get$title();
    return e.innerHTML = "", e.append(k(t)), this;
  }
  setContent(t, e = "replace") {
    const i = this.get$content();
    return e === "replace" ? (i.innerHTML = "", i.append(k(t))) : e === "append" ? i.append(k(t)) : i.prepend(k(t)), this;
  }
  setIcons(t) {
    const e = this.get$icons();
    e.innerHTML = "";
    for (const i of t) {
      const n = h("button", {
        className: `ipe-modal-modal__icon ${i.className}`,
        attrs: { type: "button" }
      });
      n.addEventListener("click", i.method), e.appendChild(n);
    }
    return this;
  }
  setButtons(t, e) {
    const i = this.$buttonsLeft, n = this.$buttonsRight;
    [i, n].forEach((l) => l.innerHTML = ""), this.buttonElsLeft = [], this.buttonElsRight = [], this.keyMap.clear();
    const o = e ?? this.$footer;
    if (o === this.$footer)
      t.forEach((l) => this.addButton(l)), t.length === 0 && (this.$footer.style.display = "none");
    else {
      o.innerHTML = "";
      for (const l of t) {
        const r = this.generateButton(l);
        o.appendChild(r);
      }
    }
    return this;
  }
  generateButton(t) {
    const e = t.type ?? "button", i = e === "link" ? h("a") : h("button", { attrs: { type: "button" } });
    t.id && (i.id = t.id), i.className = `ipe-modal-btn ${t.className ?? ""}`.trim();
    const n = k(t.label ?? "OK");
    if (i.append(n), e === "link" && t.href && (i.href = t.href), t.method && i.addEventListener("click", (o) => {
      if (i._ipe_tmpDisabled) {
        o.preventDefault(), o.stopPropagation();
        return;
      }
      t.method.call(i, o, this);
    }), typeof t.closeAfter == "number" && t.closeAfter >= 0 && i.addEventListener("click", () => {
      window.setTimeout(() => this.close(), t.closeAfter);
    }), typeof t.enableAfter == "number" && t.enableAfter > 0) {
      e === "button" && i.setAttribute("disabled", "true"), i._ipe_tmpDisabled = !0, i.setAttribute("aria-disabled", "true");
      const o = () => {
        e === "button" && i.removeAttribute("disabled"), delete i._ipe_tmpDisabled, i.removeAttribute("aria-disabled");
      };
      window.setTimeout(o, t.enableAfter);
    }
    if (t.keyPress) {
      const l = String(t.keyPress).split(/[\,\|]+/g).map((r) => r.trim()).filter(Boolean);
      for (const r of l) {
        const a = dt(r);
        a && this.keyMap.set(a, i);
      }
    }
    return i;
  }
  /** Dynamically add button(s) into footer. Supports insertion index per side. */
  addButton(t, e) {
    this.$footer && (this.$footer.style.display = "");
    const i = t.side ?? "right", n = i === "left" ? this.$buttonsLeft : this.$buttonsRight, o = i === "left" ? this.buttonElsLeft : this.buttonElsRight, l = this.generateButton(t), r = Math.max(0, Math.min(e ?? o.length, o.length));
    return r >= n.children.length ? n.appendChild(l) : n.insertBefore(l, n.children[r]), o.splice(r, 0, l), this;
  }
  /** Remove button by element / id / global index (left first, then right). */
  removeButton(t) {
    const e = this.buttonElsLeft, i = this.buttonElsRight, n = [...e, ...i];
    let o = null;
    if (t === "*")
      return n.forEach((r) => {
        this.keyMap.delete(r.id), r.parentElement?.removeChild(r);
      }), this.$footer && (this.$footer.style.display = "none"), this;
    if (typeof t == "number" ? o = n[t] ?? null : typeof t == "string" ? o = n.find((r) => r.id === t) ?? null : t instanceof HTMLElement && (o = n.find((r) => r === t) ?? null), !o) return this;
    for (const [r, a] of this.keyMap.entries()) a === o && this.keyMap.delete(r);
    let l = e.indexOf(o);
    return l !== -1 ? (e.splice(l, 1), o.parentElement?.removeChild(o)) : (l = i.indexOf(o), l !== -1 && (i.splice(l, 1), o.parentElement?.removeChild(o))), e.length === 0 && i.length === 0 && this.$footer && (this.$footer.style.display = "none"), this;
  }
  changePreviewState() {
    return this.get$modal().classList.toggle("is-fullscreen"), this;
  }
  setModalHeight(t, e = "height") {
    const i = this.get$window(), n = Math.max(0, window.innerHeight - t);
    return i.style[e] = `${n}px`, n;
  }
  setOptions(t, e) {
    return typeof t == "string" ? this.options[t] = e : Object.assign(this.options, t), this;
  }
  setPluginName(t) {
    return this.$window && (this.$window.className = this.$window.className.replace(
      `plugin--${this.pluginName}`,
      `plugin--${t}`
    )), this.pluginName = t, this;
  }
  // ------------------------------ helpers ------------------------------- //
  applyAnimation(t) {
    const e = this.get$modal(), i = this.get$window(), n = this.$backdrop, o = this.options.modalAnimation ?? this.options.animation, l = typeof o == "string" ? o : o && (t ? o.show : o.hide), r = this.options.backdropAnimation ?? this.options.animation, a = typeof r == "string" ? r : r && (t ? r.show : r.hide);
    !l || l === !1 ? (e.style.transition = "none", i.style.animation = "none", i.style.removeProperty("--ipe-modal-anim")) : (e.style.removeProperty("transition"), i.style.setProperty("--ipe-modal-anim", l)), n && (!a || a === !1 ? n.style.transition = "none" : n.style.removeProperty("transition"));
  }
  on(t, e) {
    return this._hooks.push({ type: t, listener: e }), () => this.off(t, e);
  }
  off(t, e) {
    return this._hooks = this._hooks.filter(
      (i) => i.type !== t && (e ? i.listener !== e : !0)
    ), this;
  }
  once(t, e) {
    const i = this.on(t, (n) => (i(), e(n)));
    return i;
  }
  emit(t, e) {
    const i = this._hooks.filter((a) => a.type === t);
    let n = !0;
    for (const a of i) {
      const u = new CustomEvent(t, { detail: this, cancelable: e }), f = a.listener(u);
      if (u.defaultPrevented && (n = !1), f === !1 && (n = !1), !n) break;
    }
    const o = this.$modal ?? document.body, l = new CustomEvent(t, { detail: this, cancelable: e });
    return (!o.dispatchEvent(l) || l.defaultPrevented) && (n = !1), n;
  }
  focusFirst() {
    const t = this.get$modal(), e = H(t);
    e.length ? e[0].focus() : t.focus({ preventScroll: !0 });
  }
  onKeyDown(t) {
    if (d.top() !== this) return;
    if (t.key === "Escape") {
      t.preventDefault(), this.close();
      return;
    }
    const e = this.get$modal();
    if (!e.contains(document.activeElement)) return;
    if (t.key === "Tab") {
      const r = H(e);
      if (!r.length) return;
      const a = r[0], u = r[r.length - 1], f = document.activeElement;
      t.shiftKey && f === a ? (t.preventDefault(), u.focus()) : !t.shiftKey && f === u && (t.preventDefault(), a.focus());
    }
    const i = t.ctrlKey || t.altKey || t.metaKey, n = t.target;
    if (!i && (n && ["INPUT", "TEXTAREA"].includes(n.tagName) || n.contentEditable === "true"))
      return;
    const o = ft(t), l = this.keyMap.get(o);
    if (l) {
      t.preventDefault(), l.click();
      return;
    }
  }
  setZIndex(t) {
    this.$backdrop && (this.$backdrop.style.zIndex = String(t)), this.$modal && (this.$modal.style.zIndex = String(t + 1));
  }
  /** Bring this modal to the top of the stack. */
  bringToFront() {
    return d.remove(this), d.push(this), this;
  }
  isAnimationDisabled() {
    const t = this.options.modalAnimation ?? this.options.animation;
    return t === !1 || t == null;
  }
  shouldLockBodyOnOpen() {
    return this.options.backdrop === !1 || this.options.bodyScroll !== !1 ? !1 : !d.stack.some(
      (e) => e !== this && e.options.backdrop !== !1 && e.options.bodyScroll === !1
    );
  }
  shouldUnlockBodyOnClose() {
    return this.options.backdrop === !1 || this.options.bodyScroll !== !1 ? !1 : !d.stack.some(
      (e) => e !== this && e.options.backdrop !== !1 && e.options.bodyScroll === !1
    );
  }
  // ------------------------------ drag handlers ------------------------------- //
  onDragStart(t) {
    if (this.options.backdrop !== !1 || !this.options.draggable) return;
    t.preventDefault(), this.isDragging = !0, this.bringToFront(), this.dragStartX = t.clientX, this.dragStartY = t.clientY;
    const e = this.get$modal(), i = e.getBoundingClientRect();
    this.modalStartX = i.left + window.pageXOffset, this.modalStartY = i.top + window.pageYOffset, e.style.transform = "none", e.style.left = `${this.modalStartX}px`, e.style.top = `${this.modalStartY}px`, document.addEventListener("pointermove", this.onDragMove), document.addEventListener("pointerup", this.onDragEnd), e.classList.add("is-dragging");
  }
  // ------------------------------ toast ------------------------------- //
  /** Show as toast (no backdrop, container stack). */
  showToast(t) {
    this.$window || this.init();
    const e = mt(t.position ?? "top right"), i = this.get$window();
    this.isToast = !0, i.style.pointerEvents = "auto", this.applyAnimation(!0), e.appendChild(i);
    const n = (typeof this.options.closeAfter == "number" ? this.options.closeAfter : this.options.closeAfter?.time) ?? 3e3, o = (typeof this.options.closeAfter == "number" ? !0 : this.options.closeAfter?.resetOnHover) ?? !0;
    return n > 0 && (this.startCloseTimer(n), o && (i.addEventListener("mouseenter", this.stopCloseTimer), i.addEventListener("mouseleave", () => this.startCloseTimer(n)))), this.isOpen = !0, this.options.onShow?.(this), g.push(this), this.emit(
      "toast.show"
      /* ToastShow */
    ), this.emit(
      "modal.show"
      /* Show */
    ), this;
  }
  // ------------------------------ static helpers --------------------------- //
  static show(t, e) {
    return new this(t).init().show();
  }
  static createObject(t, e) {
    return new this(t);
  }
  static close(t) {
    if (!t) {
      const o = d.top();
      return o?.close(), o;
    }
    const e = typeof t == "string" ? t : t.id, i = d.stack.find((o) => o.modalId === e);
    if (i)
      return i.close(), i;
    const n = g.find((o) => o.modalId === e);
    return n?.close(), n;
  }
  static closeAll(t, e) {
    const i = new Set((Array.isArray(e) ? e : e ? [e] : []).map(String)), n = new Set((Array.isArray(t) ? t : t ? [t] : []).map(String));
    return d.closeAll(t, e), [...g].forEach((o) => {
      const l = o.modalId, r = n.size ? n.has(o.pluginName) : !0, a = i.has(l);
      r && !a && o.close();
    }), d.top() ?? new N();
  }
  static removeAll() {
    d.removeAll(), [...g].forEach((t) => t.destroy());
  }
  static dialog(t, e) {
    const i = new this({
      sizeClass: "dialog",
      buttons: [
        {
          label: "OK",
          className: "is-primary is-ghost",
          method: (n, o) => {
            e?.(n, o), n.defaultPrevented || i.close();
          },
          keyPress: "Enter"
        }
      ],
      ...t
    });
    return i.init().show();
  }
  static confirm(t, e) {
    t.title ??= "Confirm", t.content ??= "Are you sure you want to perform this action?";
    const i = t.okBtn ?? { label: "OK", className: "is-primary is-ghost" }, n = t.cancelBtn ?? { label: "Cancel", className: "is-danger is-ghost" };
    return new this({
      sizeClass: "dialog",
      ...t,
      buttons: [
        {
          label: n.label,
          className: n.className,
          keyPress: "n",
          method: (l, r) => {
            e?.(!1, r, l), r.close();
          }
        },
        {
          label: i.label,
          className: i.className,
          keyPress: "y",
          method: (l, r) => {
            e?.(!0, r, l), l.defaultPrevented || r.close();
          }
        }
      ]
    }).init().show();
  }
  static getDefaultNotifyIcon(t) {
    switch (t) {
      case "success":
        return /* @__PURE__ */ c(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            class: "icon icon-tabler icons-tabler-filled icon-tabler-circle-check",
            children: [
              /* @__PURE__ */ c("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
              /* @__PURE__ */ c("path", { d: "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" })
            ]
          }
        );
      case "error":
        return /* @__PURE__ */ c(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            class: "icon icon-tabler icons-tabler-filled icon-tabler-alert-triangle",
            children: [
              /* @__PURE__ */ c("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
              /* @__PURE__ */ c("path", { d: "M12 1.67c.955 0 1.845 .467 2.39 1.247l.105 .16l8.114 13.548a2.914 2.914 0 0 1 -2.307 4.363l-.195 .008h-16.225a2.914 2.914 0 0 1 -2.582 -4.2l.099 -.185l8.11 -13.538a2.914 2.914 0 0 1 2.491 -1.403zm.01 13.33l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -7a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" })
            ]
          }
        );
      case "warning":
        return /* @__PURE__ */ c(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            class: "icon icon-tabler icons-tabler-filled icon-tabler-alert-circle",
            children: [
              /* @__PURE__ */ c("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
              /* @__PURE__ */ c("path", { d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" })
            ]
          }
        );
      case "info":
        return /* @__PURE__ */ c(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            class: "icon icon-tabler icons-tabler-filled icon-tabler-info-circle",
            children: [
              /* @__PURE__ */ c("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
              /* @__PURE__ */ c("path", { d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z" })
            ]
          }
        );
      case "dialog":
        return /* @__PURE__ */ c(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "icon icon-tabler icons-tabler-outline icon-tabler-message-dots",
            children: [
              /* @__PURE__ */ c("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
              /* @__PURE__ */ c("path", { d: "M12 11v.01" }),
              /* @__PURE__ */ c("path", { d: "M8 11v.01" }),
              /* @__PURE__ */ c("path", { d: "M16 11v.01" }),
              /* @__PURE__ */ c("path", { d: "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z" })
            ]
          }
        );
      case "confirm":
        return /* @__PURE__ */ c(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            class: "icon icon-tabler icons-tabler-filled icon-tabler-copy-check",
            children: [
              /* @__PURE__ */ c("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
              /* @__PURE__ */ c("path", { d: "M18.333 6a3.667 3.667 0 0 1 3.667 3.667v8.666a3.667 3.667 0 0 1 -3.667 3.667h-8.666a3.667 3.667 0 0 1 -3.667 -3.667v-8.666a3.667 3.667 0 0 1 3.667 -3.667zm-3.333 -4c1.094 0 1.828 .533 2.374 1.514a1 1 0 1 1 -1.748 .972c-.221 -.398 -.342 -.486 -.626 -.486h-10c-.548 0 -1 .452 -1 1v9.998c0 .32 .154 .618 .407 .805l.1 .065a1 1 0 1 1 -.99 1.738a3 3 0 0 1 -1.517 -2.606v-10c0 -1.652 1.348 -3 3 -3zm1.293 9.293l-3.293 3.292l-1.293 -1.292a1 1 0 0 0 -1.414 1.414l2 2a1 1 0 0 0 1.414 0l4 -4a1 1 0 0 0 -1.414 -1.414" })
            ]
          }
        );
      default:
        return null;
    }
  }
  static notify(t, e, i) {
    if (e?.overrideOther && [...g].forEach((r) => r.close()), typeof e.title > "u") {
      const r = t || "Notification";
      e.title = r[0].toUpperCase() + r.slice(1).toLowerCase();
    }
    const n = e.icon ?? this.getDefaultNotifyIcon(t);
    n && (n instanceof Element && n.classList.add("ipe-modal-notify-icon"), e.title = /* @__PURE__ */ c(nt, { children: [
      n,
      e.title
    ] })), t === "confirm" && (typeof e.closeAfter > "u" && (e.closeAfter = 0), e.okBtn || (e.okBtn = { label: "OK" })), e.okBtn && (typeof e.okBtn != "object" && (e.okBtn = { label: "OK" }), e.okBtn.label ??= "OK", e.okBtn.className ??= "is-primary is-text ok-btn", e.okBtn.method = (r, a) => {
      i?.(!0, a, r), a.close();
    }), e.cancelBtn && (typeof e.cancelBtn != "object" && (e.cancelBtn = { label: "Cancel" }), e.cancelBtn.label ??= "Cancel", e.cancelBtn.className ??= "is-danger is-text cancel-btn", e.cancelBtn.method = (r, a) => {
      i?.(!1, a, r), a.close();
    }), e.buttons = [e.cancelBtn, e.okBtn, ...e.buttons ?? []].filter(
      Boolean
    );
    const o = `is-notify type-${t || "default"} ${e.className ?? ""}`, l = new this({
      ...e,
      className: o,
      sizeClass: "auto",
      center: !1,
      fitScreen: !1,
      closeIcon: !0,
      outSideClose: !1,
      bodyScroll: !0,
      buttons: e.buttons ?? []
    });
    return l.setPluginName("toast"), l.showToast({
      position: e.position ?? "top right"
    });
  }
}
const g = [];
function mt(s = "top right") {
  const t = "ipe-modal-toast-container", e = `${t}-${s.replace(/[\s-\.|\/]+/g, "-")}`;
  let i = document.getElementById(e);
  return i || (i = h("div", {
    className: `${t} ${s}`,
    attrs: { id: e, "data-position": s }
  }), document.body.appendChild(i)), i;
}
export {
  N as IPEModal,
  P as IPEModalEvent
};
//# sourceMappingURL=index.js.map
